import { SendFilled } from '@carbon/icons-react';
import * as React from 'react';

import { Button } from 'bones/design-system/components/Button';
import { Input } from 'bones/design-system/components/form/Input';
import { LoadingIcon } from 'bones/design-system/components/icons/LoadingIcon';

export interface VoiceboxChatInputProps {
  autoFocus?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  inputTestId?: string;
  loading?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onClickSend?: () => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  placeholder?: string;
  sendTestId?: string;
  value?: string;
}

export const VoiceboxChatInput: React.VFC<VoiceboxChatInputProps> = ({
  autoFocus,
  inputRef,
  inputTestId,
  loading,
  onChange,
  onClickSend,
  onKeyDown,
  placeholder,
  sendTestId,
  value,
}) => (
  <div className="vb-voicebox-chat-input">
    <Input
      autoComplete="off"
      autoFocus={autoFocus}
      clearable={false}
      divider={false}
      inputRef={inputRef}
      label=""
      minimal
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      rightElement={
        <Button
          className="vb-voicebox-chat-input-button"
          disabled={loading}
          leftIcon={loading ? LoadingIcon : SendFilled}
          onClick={onClickSend}
          size="lg"
          testId={sendTestId}
          variant="primary-accent"
        />
      }
      size="lg-outside"
      testId={inputTestId}
      value={value}
    />
  </div>
);
